var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main-container"},[_c('img',{staticClass:"a-img",attrs:{"title":_vm.title,"src":_vm.icon}})])
}
var staticRenderFns = []

export { render, staticRenderFns }